/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { getOrganizationAccountUrl } from 'app/scripts/controller/urls';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardMenuVisTemplate } from 'app/scripts/views/templates/BoardMenuVisTemplate';
import { CantAddBoardToOrgTemplate } from 'app/scripts/views/templates/CantAddBoardToOrgTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface BoardOrgSelectPermLevelView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class BoardOrgSelectPermLevelView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'change visibility';

    // @ts-expect-error TS(2339): Property 'tagName' does not exist on type 'BoardOr... Remove this comment to see the full error message
    this.prototype.tagName = 'ul';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'BoardOrg... Remove this comment to see the full error message
    this.prototype.events = { 'click .js-select': 'selectVis' };

    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.className = 'pop-over-list';
  }

  render() {
    const org = this.options.organization;

    if (
      !org.canSetVisibility('private') &&
      !org.canSetVisibility('org') &&
      !org.canSetVisibility('enterprise') &&
      !org.canSetVisibility('public')
    ) {
      const data = {
        isOrgAdmin: org.owned(),
        orgSettingsUrl: getOrganizationAccountUrl(org),
        organization: org.toJSON(),
      };
      this.$el.html(templates.fill(CantAddBoardToOrgTemplate, data));
    } else {
      const current = this.model.getPref('permissionLevel');
      const enterprise = org != null ? org.getEnterprise() : undefined;

      this.$el.html(
        BoardMenuVisTemplate({
          current,
          canChange: true,
          mustChange: !org.canSetVisibility(current),
          hasSuperAdmins: org.hasPremiumFeature('superAdmins'),
          hasOrg: true,
          orgName: org.get('displayName'),
          privateRestricted: !org.canSetVisibility('private'),
          orgRestricted: !org.canSetVisibility('org'),
          enterpriseRestricted: !org.canSetVisibility('enterprise'),
          publicRestricted: !org.canSetVisibility('public'),
          hasEnterprise:
            org != null ? org.belongsToRealEnterprise() : undefined,
          enterpriseName:
            enterprise != null ? enterprise.get('displayName') : undefined,
          isTemplate: this.model.isTemplate(),
          isPaidOrg: org?.hasPaidProduct(),
        }),
      );
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectVis(e: any) {
    stopPropagationAndPreventDefault(e);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target).closest('.js-select');

    if (
      $target.hasClass('disabled') ||
      $target.closest('.js-disabled').length
    ) {
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'edit-board/idOrganization',
      // @ts-expect-error TS(2322): Type '"boardOrgSelectPermLevelInlineDialog"' is no... Remove this comment to see the full error message
      source: 'boardOrgSelectPermLevelInlineDialog',
    });

    const setting = $target.attr('name');

    if (this.options.idOrganizationSource) {
      this.modelCache
        .get('Organization', this.options.idOrganizationSource)
        ?.boardList.remove(this.model);
    }
    this.model.update(
      {
        traceId,
        idOrganization: this.options.organization.id,
        'prefs/permissionLevel': setting,
      },
      tracingCallback({
        taskName: 'edit-board/idOrganization',
        // @ts-expect-error TS(2322): Type '"boardOrgSelectPermLevelInlineDialog"' is no... Remove this comment to see the full error message
        source: 'boardOrgSelectPermLevelInlineDialog',
        traceId,
      }),
    );
    this.options.organization.boardList.add(this.model);

    return PopOver.hide();
  }
}

BoardOrgSelectPermLevelView.initClass();
export { BoardOrgSelectPermLevelView };
